module.exports = __webpack_public_path__ + "static/cocoa_cake_slika6-59172ca301e9166588e39053614ddc2b.jpg";